import { useQuery } from '@tanstack/react-query';
import { axiosLib } from '@/lib/axios';
import { House } from '../types';

interface HousesResponse {
  colocations: House[];
}

const fetchAvailableHouses = async (limit: number = 6): Promise<HousesResponse> => {
  const { data } = await axiosLib.get<HousesResponse>(`/api/houses/available`, {
    params: {
      limit,
    },
  });
  return data;
};

export const useAvailableHouses = (limit: number = 6) => {
  return useQuery({
    queryKey: ['houses', 'available', limit],
    queryFn: () => fetchAvailableHouses(limit),
  });
};
